import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white border border-gray-200 rounded-xl p-4 mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "py-8 flex justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-center text-xs text-gray-600 font-medium" }, "Activity", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-right text-xs text-gray-600 font-medium" }, "Actions", -1)
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "px-3 py-3 text-xs" }
const _hoisted_9 = {
  key: 0,
  class: "ml-2 text-[10px] uppercase tracking-wide text-gray-400"
}
const _hoisted_10 = { class: "px-3 py-3 text-xs" }
const _hoisted_11 = { class: "px-3 py-3 text-xs" }
const _hoisted_12 = { class: "px-3 py-3 text-xs" }
const _hoisted_13 = { class: "px-3 py-3 text-xs" }
const _hoisted_14 = { class: "px-3 py-3 text-xs text-center" }
const _hoisted_15 = ["disabled", "title", "onClick"]
const _hoisted_16 = { class: "px-3 py-3 text-xs text-right" }
const _hoisted_17 = { class: "inline-flex items-center gap-2 flex-wrap justify-end" }
const _hoisted_18 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = {
  key: 0,
  class: "text-sm text-gray-500 py-6 text-center"
}

import {
  InternalAdmin,
  InternalAdminSortDir,
  InternalAdminSortKey,
} from "@/stores/internalAdminStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalAdminsTableComponent',
  props: {
    admins: {},
    loading: { type: Boolean },
    actionLoadingId: {},
    currentUserId: {},
    sortKey: {},
    sortDir: {}
  },
  emits: ["sort", "deactivate", "activate", "resendInvite", "resetPassword", "delete", "viewActivity"],
  setup(__props: any, { emit }) {

const props = __props;





const emitSort = (key: InternalAdminSortKey) => emit("sort", key);

const sortIndicator = (key: InternalAdminSortKey) => {
  if (props.sortKey !== key) return "";
  return props.sortDir === "asc" ? "▲" : "▼";
};

const formatDate = (value?: string) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toISOString().substring(0, 10);
};

const statusLabel = (state: InternalAdmin["accountState"]) => {
  if (state === "active") return "Active";
  if (state === "invite-sent") return "Invite Sent";
  return "Inactive";
};

const statusClass = (state: InternalAdmin["accountState"]) => {
  if (state === "active") return "bg-green-100 text-green-800";
  if (state === "invite-sent") return "bg-blue-100 text-blue-800";
  return "bg-gray-200 text-gray-700";
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading && _ctx.admins.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "px-3 py-3 text-left text-xs text-gray-600 font-medium cursor-pointer select-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emitSort('name')))
                }, " Name " + _toDisplayString(sortIndicator('name')), 1),
                _createElementVNode("th", {
                  class: "px-3 py-3 text-left text-xs text-gray-600 font-medium cursor-pointer select-none",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emitSort('email')))
                }, " Email " + _toDisplayString(sortIndicator('email')), 1),
                _createElementVNode("th", {
                  class: "px-3 py-3 text-left text-xs text-gray-600 font-medium cursor-pointer select-none",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emitSort('status')))
                }, " Status " + _toDisplayString(sortIndicator('status')), 1),
                _createElementVNode("th", {
                  class: "px-3 py-3 text-left text-xs text-gray-600 font-medium cursor-pointer select-none",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emitSort('createdAt')))
                }, " Created " + _toDisplayString(sortIndicator('createdAt')), 1),
                _createElementVNode("th", {
                  class: "px-3 py-3 text-left text-xs text-gray-600 font-medium cursor-pointer select-none",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (emitSort('updatedAt')))
                }, " Updated " + _toDisplayString(sortIndicator('updatedAt')), 1),
                _hoisted_5,
                _hoisted_6
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admins, (admin, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: admin._id,
                  class: _normalizeClass([
              index % 2 === 1 ? 'bg-gray-100' : '',
              admin._id === _ctx.currentUserId ? 'opacity-50 text-gray-500 italic' : ''
            ]),
                  title: admin._id === _ctx.currentUserId ? 'This is your account — no actions are available.' : ''
                }, [
                  _createElementVNode("td", _hoisted_8, [
                    _createTextVNode(_toDisplayString(`${admin.firstName || ''} ${admin.lastName || ''}`.trim() || '-') + " ", 1),
                    (admin._id === _ctx.currentUserId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(you)"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(admin.email || '-'), 1),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                  'inline-block px-2 py-1 rounded-full text-xs font-medium',
                  admin._id === _ctx.currentUserId ? 'bg-gray-100 text-gray-500' : statusClass(admin.accountState)
                ])
                    }, _toDisplayString(statusLabel(admin.accountState)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(formatDate(admin.createdAt)), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(formatDate(admin.updatedAt)), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-indigo-700 text-xs font-semibold border border-indigo-200 px-2 py-1 bg-indigo-50 rounded disabled:opacity-50",
                      disabled: admin._id === _ctx.currentUserId || admin.accountState === 'invite-sent',
                      title: admin.accountState === 'invite-sent' ? 'Admin invite sent - no activity yet.' : undefined,
                      onClick: ($event: any) => (_ctx.$emit('viewActivity', admin))
                    }, " View Activity ", 8, _hoisted_15)
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (admin._id === _ctx.currentUserId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "—"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (admin.accountState === 'invite-sent')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "text-blue-700 text-xs font-semibold border border-blue-200 px-2 py-1 bg-blue-50 rounded disabled:opacity-50",
                                  disabled: _ctx.actionLoadingId === admin._id,
                                  onClick: ($event: any) => (_ctx.$emit('resendInvite', admin))
                                }, " Resend Invite ", 8, _hoisted_19))
                              : (admin.accountState === 'active')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "text-yellow-700 text-xs font-semibold border border-yellow-200 px-2 py-1 bg-yellow-50 rounded disabled:opacity-50",
                                    disabled: _ctx.actionLoadingId === admin._id,
                                    onClick: ($event: any) => (_ctx.$emit('deactivate', admin))
                                  }, " Deactivate ", 8, _hoisted_20))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "text-green-700 text-xs font-semibold border border-green-200 px-2 py-1 bg-green-50 rounded disabled:opacity-50",
                                    disabled: _ctx.actionLoadingId === admin._id,
                                    onClick: ($event: any) => (_ctx.$emit('activate', admin))
                                  }, " Activate ", 8, _hoisted_21)),
                            (admin.accountState !== 'invite-sent')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  type: "button",
                                  class: "text-gray-700 text-xs font-semibold border border-gray-300 px-2 py-1 bg-white rounded disabled:opacity-50",
                                  disabled: _ctx.actionLoadingId === admin._id,
                                  onClick: ($event: any) => (_ctx.$emit('resetPassword', admin))
                                }, " Reset Password ", 8, _hoisted_22))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-red-700 text-xs font-semibold border border-red-200 px-2 py-1 bg-red-50 rounded disabled:opacity-50",
                              disabled: _ctx.actionLoadingId === admin._id,
                              onClick: ($event: any) => (_ctx.$emit('delete', admin))
                            }, " Delete ", 8, _hoisted_23)
                          ], 64))
                    ])
                  ])
                ], 10, _hoisted_7))
              }), 128))
            ])
          ]),
          (_ctx.admins.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No internal admins found. "))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})